import { useCallback } from 'react'

import {
  GET_DEACTIVATE_SAVED_BANK_CARD,
  convertParams,
  convertResult,
} from 'app/common/api/requests/payments/acquiring2/deactivate_saved_bank_card/get'

import { api } from 'app/api'
import { Params } from 'app/dataTypes/acquiring/recurrent/deactivate'

export const useDeactivateSavedBankCard = () => {
  const deactivate = useCallback(async ({ bankCardId }: Params) => {
    const res = await api.request(GET_DEACTIVATE_SAVED_BANK_CARD, {
      error: 'Не удалось убрать карту из сохраненных',
      convertions: {
        convertParams,
        convertResult,
      },
      params: {
        bankCardId,
      },
    })
    return !!res
  }, [])

  return { deactivate }
}
